import React from "react";
import {useDispatch} from "react-redux";
import { setTotalTicketPrice, setTotalHeadCount } from '../../store/adminSlice';

function OtherInfoandSubmit({ formData , setFormData,eventPrice,seteventprice, checkBoxStates,setcheckBoxStates}) {

  const dispatch = useDispatch();

  const CalculateTotalGuests = ()=>
    {
      let totalguests = 0
      if(checkBoxStates.isEventChecked) {
         totalguests=parseStringToInt(formData.numberOfAdult)
      }
      else {
        totalguests=parseStringToInt(formData.numberBelow6) + parseStringToInt(formData.numberBetween6To12) 
        + parseStringToInt(formData.totalVeg) + parseStringToInt(formData.totalNonveg);
        dispatch(setTotalHeadCount(totalguests));
      }
      return totalguests;
    }
    const CalculateTotalCost = ()=>
      {
        let totalCost = 0;
        let subscriptionAmount = 0;

        

    // Calculate subscriptionAmount based on checkBoxStates
    if (checkBoxStates && checkBoxStates.isAllDayChecked) {
      formData.registrationType = "ALL_DAYS";
      subscriptionAmount = (parseStringToInt(formData.numberBelow6) * eventPrice.priceBelow6)
        + (parseStringToInt(formData.numberBetween6To12) * eventPrice.price6to12)
        + (parseStringToInt(formData.totalVeg) * eventPrice.priceAdult)
        + (parseStringToInt(formData.totalNonveg) * eventPrice.priceAdult);
     
    } else if (checkBoxStates && checkBoxStates.isSaturdayChecked) {
      formData.registrationType = "SATURDAY_ONLY";
      subscriptionAmount = (parseStringToInt(formData.numberBelow6) * eventPrice.saturdayPriceBelow6)
        + (parseStringToInt(formData.numberBetween6To12) * eventPrice.saturdayPrice6To12)
        + (parseStringToInt(formData.totalVeg) * eventPrice.saturdayPriceAdult)
        + (parseStringToInt(formData.totalNonveg) * eventPrice.saturdayPriceAdult);
        
    } else if (checkBoxStates && checkBoxStates.isSundayChecked) {
      formData.registrationType = "SUNDAY_ONLY";
      subscriptionAmount = (parseStringToInt(formData.numberBelow6) * eventPrice.sundayPriceBelow6)
        + (parseStringToInt(formData.numberBetween6To12) * eventPrice.sundayPrice6To12)
        + (parseStringToInt(formData.totalVeg) * eventPrice.sundayPriceAdult)
        + (parseStringToInt(formData.totalNonveg) * eventPrice.sundayPriceAdult);

       
    }

    else {
       formData.registrationType = "EVENT_ONLY";
      subscriptionAmount = (parseStringToInt(formData.numberOfAdult) * eventPrice.eventOnlyPriceAdult);
    }

    
// alert(subscriptionAmount);
   totalCost = subscriptionAmount + (subscriptionAmount * 1.99 / 100) + 0.49;
   const roundedTotalCost = Math.ceil(totalCost * 100) / 100;
    formData.totalTicketPrice = roundedTotalCost;
        
        dispatch(setTotalTicketPrice(roundedTotalCost));
        return roundedTotalCost;
      }
         
  return (
    <div className="other-info-container">
     <tr><td><label >Registration Name : <label style={{fontWeight:'bold', fontSize:'22px'}} > {(formData.firstName) + " " + (formData.lastName)} </label></label></td></tr>  
     <tr><td><label >Email : <label style={{fontWeight:'bold', fontSize:'22px'}} > {formData.email} </label></label></td></tr>  
     <tr><td><label >Phone : <label style={{fontWeight:'bold', fontSize:'22px'}} >{formData.phoneNumber} </label></label></td></tr>    
    
     <tr><td><label style={{fontWeight:'bold', fontSize:'25px'}} >Guest Details</label></td></tr>
     {!checkBoxStates.isEventChecked && 
      <>
      <tr><td><label >Number of kids (Age Below 6) : <label style={{fontWeight:'bold'}} >{formData.numberBelow6}</label> </label></td></tr>
      <tr><td><label >Number of kids (Age 6-12) : <label style={{fontWeight:'bold'}} > {formData.numberBetween6To12} </label> </label></td></tr>
      <tr><td><label >Number of Adults (Veg): <label style={{fontWeight:'bold'}} > {formData.totalVeg} </label> </label></td></tr>
      <tr><td><label >Number of Adults (Non-veg): <label style={{fontWeight:'bold'}} >{formData.totalNonveg} </label> </label></td></tr>
      </>
     }
     {checkBoxStates.isEventChecked && 
      <>
      <tr><td><label >Number of Adults : <label style={{fontWeight:'bold'}} >{formData.totalNonveg}</label> </label></td></tr>
      <tr><td><label >Number of Juniors : <label style={{fontWeight:'bold'}} > {formData.numberBetween6To12} </label> </label></td></tr>
      </>
     }
     <tr><td><label >Total Guests : <label style={{fontWeight:'bold', fontSize:'22px'}} > {CalculateTotalGuests()} </label> </label></td></tr>
     <tr><td><label >Total Cost : <label style={{fontWeight:'bold', fontSize:'22px'}} > ${CalculateTotalCost()} </label> </label></td></tr>
  
    </div>
  );

  
   
  function parseStringToInt(str) {
    // Check if the input is null or undefined
    if (str === null || str === undefined) {
      
      return 0;
    }
  
    // Attempt to parse the string to an integer
    let num = parseInt(str, 10); // Specify radix 10 for decimal numbers
  
    // Check if the result is NaN (Not-a-Number)
    if (isNaN(num)) {
     
      return 0;
    }
  
    return num;
  }
  


}

export default OtherInfoandSubmit;
